import { useMediaQuery } from "react-responsive";

const useIsDesktopDevice = () => {
  const isLargeScreen = useMediaQuery({ minWidth: 1024 });
  const isTouchDevice =
    typeof window !== "undefined" && "ontouchstart" in window;

  return isLargeScreen && !isTouchDevice;
};

export { useIsDesktopDevice };
